// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"5f89ee34","275":"98ee39cd","651":"1d8d8032","756":"0959bc4d"}[chunkId] + ".chunk.css";
};